export default __webpack_public_path__ + "static/media/icon-skype-link.302f0a42.svg";